<div id="word-selector">
    @for( w of verse.words; track w ) {
    <span [ngClass]="verse.language" 
        [ngClass]="{'selected': selected.get(w.firstId) || false}" 
        [attr.data-wordid]="w.firstId" 
        (click)="clickWord(w.firstId)">{{w.text}}</span>
    }
</div> 
<div>
<button mat-button (click)="clearSelection()">Clear selection</button>
</div>